export default {
  resource:{
    zh: {
      title:"假期",
      jjr: "日期",
      rq1: "开始日期",
      rq2: "结束日期",
      jjrmc: "日期说明",
      rqtype:	"日期类型",
      jbtype:	"日期属性",
      timesl:	"假期时间",
      tbdz:	"备注",
      nullDate:"日期不能为空！",
      nullTime:"时间不能为空！",
      existed:"日期已经存在，请检查！",
      jbtype1:	"有薪年假",
      jbtype2:	"有薪假期",
      jbtype3:	"工作时间",
      jbtype4:	"休息时间",
      jbtype5:	"节日时间",
      jbtype6:	"自由上班",
      rqtype1:	"一般节假日",
      rqtype2:	"指定工作日",
      rqtype3:	"指定休息日",
      rqtype4:	"法定节假日",
    }
  },
  delConf:["jjr"],
  delKeys:["autoid"],
  params: {
    rq1:{
      key: "jjr",
      tkey: "rq1",
      data: null,
      method: "GreaterThanOrEqual",
      type: "date"
    },
    rq2:{
      key: "jjr",
      tkey: "rq2",
      data: null,
      method: "LessThanOrEqual",
      type: "date"
    }
  },
  listDefine: [
    {key:"jjr", formatter:"fdate"}, "jjrmc"
    //{key:"rqtype", formatter:"rqtype"},{key:"jbtype", formatter:"jbtype"},
   
  ],
  formatter: {
    rqtype(t) {
      return "rqtype" + t
    },
    jbtype(t) {
      return "jbtype" + t
    }
  },
  bodyClass: "table-select", //table-multiselect table-select
  list: [],
  defaultSortName:"jjr",
  defaultSortOrder:"desc",
  sortName: "jjr",
  sortOrder: "desc",
  pageNo: 1,
  pageSize: 18,
  rowCount: 127,
  url: "calendar/",
  autoId: "autoID"

}
